<div class="tab-container">
    <div *ngIf="!numberOfNotesInModule" class="video-notes d-none d-lg-flex">
      <img src="assets/images/notes.png" alt="">
      <p>There seems to be nothing here. Create a note for your lesson now!</p>
    </div>
    <ng-template [ngIf]="numberOfNotesInModule">
      <div id="Contentaccordion" malihu-scrollbar class="contentAccordion contentAccordion--notes">
      <div *ngFor="let moduleNote of _courseNotes; index as j;">
  
        <p class="notesmoduled"><i class="icon-copy"></i> {{moduleNote.moduleName}}:
          <span>({{moduleNote.moduleLength || 0}}
            Note{{moduleNote.moduleLength==1?'':'s'}})</span>
        </p>
        <div class="courseAccordion">
          <div *ngFor="let m of moduleNote.notes; index as i" class="card">
            <div class="card-header" id="ContentOne">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseOne' + i + j"
                  [attr.aria-expanded]="contentId==m.content" [attr.aria-controls]="'collapseOne' + i + j">
                  <span class="textLabel"><span class="number"></span>{{m.title}} ({{m.notes.length}})</span>
                  <i class="icon-arrow-down"></i>
                </button>
              </h5>
            </div>
            <div [attr.id]="'collapseOne' + i + j" class="collapse" [class.show]="contentId==m.content"
              [attr.aria-labelledby]="'ContentOne' + i + j" data-bs-parent="#Contentaccordion">
              <div class="card-body">
                <ul class="messageList">
                  <li *ngFor="let n of m.notes">
                    <app-note-item [note]="n" (edit)="onEdit($event, n)" (remove)="onRemove($event)">
                    </app-note-item>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </ng-template>
    <div class="tab-control">
      <p class="notes d-lg-none">Notes <a href="javascript:void(0)" (click)="onClose()" class="icon-close tabsClosed"></a>
      </p>
      <textarea [ngModel]="description" (ngModelChange)="changeDescription($event)" class="form-control placeholder"
        placeholder="Type in your notes here" #notes (keydown)="onKeyDown($event)"></textarea>
      <div class="d-flex">
        <button [disabled]="!description" *ngIf="!isEditMode" (click)="add()" class="btn btn-light"><span>Save Note <cite
              *ngIf="description && !isExercise">At {{time | formatSec}}</cite></span></button>
        <button [disabled]="!description" *ngIf="isEditMode" (click)="edit()" class="btn btn-light"><span>Save
            Note</span></button>
        <button *ngIf="isEditMode" (click)="cancelEdit()"
          class="btn btn-outlinedark lightColor ms-2"><span>Cancel</span></button>
      </div>
    </div>
  </div>